import { render } from "./TemplateSelectionModal.vue?vue&type=template&id=f8a3953c&scoped=true"
import script from "./TemplateSelectionModal.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionModal.vue?vue&type=script&lang=js"

import "./TemplateSelectionModal.vue?vue&type=style&index=0&id=f8a3953c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a3953c"]])

export default __exports__